export default __webpack_public_path__ + "static/media/FishEggBW.6702b735.png";